import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import CampaignReport from './components/CampaignReport';

const GoogleCampaignReportPage = () => (
  <Container className="dashboard">
    <Row>
      <Col md={12}>
        <h3 className="page-title">Google Campaign Report</h3>
      </Col>
    </Row>
    <Row>
      <CampaignReport />
    </Row>
  </Container>
);

export default GoogleCampaignReportPage;
